import { render, staticRenderFns } from "./templateGenerate.vue?vue&type=template&id=4d87d13a&scoped=true"
import script from "./templateGenerate.vue?vue&type=script&lang=js"
export * from "./templateGenerate.vue?vue&type=script&lang=js"
import style0 from "./templateGenerate.vue?vue&type=style&index=0&id=4d87d13a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d87d13a",
  null
  
)

export default component.exports